export default {
  no_results: {
    title: 'Nessun risultato per «{{search}}»',
    desc: 'Spiacenti, nessuna corrispondenza trovata. Prova un termine di ricerca diverso.',
  },
  empty_menu: {
    title: 'Nessun articolo disponibile',
    desc: 'Questo menu non ha nulla da mostrare al momento. Ricontrolla presto.',
  },
};
